<template>
  <div class="inner-page">

    <!--~~~~~     PAGE CONTENT     ~~~~~-->
    <main class="inner-page__content  align-items-stretch  p-0">
      <div class="exam  w-100">

        <div class="exam__sidebar  exam__sidebar--bg-blue">

          <div class="exam__sidebar-header">
            <LogoComponent/>
          </div>

          <div class="exam__sidebar-body">

            <button class="exam__toggle-btn  collapse-btn" :class="{' collapse-btn--active':showInfo}" @click="showInfo=!showInfo">
              <span class="collapse-btn__text">{{ getTranslation('aboutTesting') }}</span>

              <span class="collapse-btn__icon-wrap">
                                  <svg class="collapse-btn__icon" width="12" height="6" viewBox="0 0 12 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path fill-rule="evenodd" clip-rule="evenodd" d="M.297.373C.733-.081 1.49-.127 1.99.27L6 3.46 10.01.27c.498-.397 1.257-.35 1.693.103.437.453.386 1.142-.113 1.539L6.79 5.73c-.452.36-1.128.36-1.58 0L.41 1.912C-.09 1.515-.14.826.297.372z"/>
                                  </svg>
                            </span>
            </button>
            <div v-if="showInfo" class="exam__data">
              <div class="exam__data">
                <div v-if="eventInfo.application && !eventInfo.application.demo" class="exam__data-group">
                  <div class="exam__data-label">{{ getTranslation('candidate') }}</div>
                  <div class="exam__data-value">{{ $store.getters['candidate/getCandidate'].fullName }}</div>
                </div>
                <div v-if="eventInfo.application && POSITION_RESOURCES.includes(eventInfo.application.resource.type.id)" class="exam__data-group">

                  <div class="exam__data-label">{{ getTranslation('position') }}</div>


                  <div v-if="eventInfo.application" class="exam__data-value">{{ eventInfo.application.resource.title }}</div>

                </div>

                <div v-else class="exam__data-group">
                  <div class="exam__data-label">{{ getTranslation('category') }}</div>
                  <div v-if="eventInfo.application" class="exam__data-value">{{ eventInfo.application.resource.resourceTitle }}</div>
                </div>

                <div class="exam__data-group">
                  <div class="exam__data-label">{{ getTranslation('dateAndTimeOccur') }}</div>
                  <div v-if="candidateEvent" class="exam__data-value">
                    {{ momentFormatDate(candidateEvent.startTime, 'DD.MM.YYYY') }},&nbsp;
                    {{ momentFormatDate(candidateEvent.startTime, 'HH:mm') }} — {{ momentFormatDate(candidateEvent.endTime, 'HH:mm') }}
                  </div>
                </div>
              </div>
            </div>


            <div class="exam__actions">

              <a class="btn  btn--main  btn--full-width" @click="candidateLogout($store.getters['candidate/getCandidatePin'])" href="javascript:void(0)">
                {{ getTranslation('logout') }}
              </a>

            </div>

          </div>

        </div>
        <!-- /.exam-sidebar  -->


        <div class="exam__content  pr-4">
          <div class="exam__actions exam__sidebar--bg-blue p-3 mt-0">
            <a class="btn  btn--white  btn--system  btn--with-icon mb-0" @click="()=>{$router.push({name:'auth.success'}).catch(()=>{})}" href="javascript:void(0)">
              <svg class="btn__icon">
                <use xlink:href="#icon__arrow-2-left"></use>
              </svg>
              {{ getTranslation('gotoBack') }}
            </a>
          </div>

          <div class="d-flex  justify-content-between  align-items-center  mb-3  pt-2">
            <h1 class="exam__page-title  mb-0">{{ getTranslation('testingResults') }}</h1>

            <div class="exam__result-stats">
              <div class="exam__result-item exam__result-item--total">
                <div class="exam__answers--point-total  exam__answers-num--total">{{ totalPoint }}</div>
                {{ getTranslation('totalPoint') }}
              </div>
              <div class="exam__result-item  exam__result-item--correct">
                <div class="exam__answers-num  exam__answers-num--correct">{{ eventResults.count_true }}</div>
                {{ getTranslation('correctsResult') }}
              </div>

              <div class="exam__result-item  exam__result-item--incorrect">
                <div class="exam__answers-num  exam__answers-num--incorrect">{{ eventResults.count_total - eventResults.count_true }}</div>
                {{ getTranslation('incorrectsResult') }}
              </div>
            </div>
          </div>
          <table class="table-3  table-3--full-width">
            <thead class="table-3__head">
            <tr class="table-3__row">
              <th class="table-3__cell  table-3__hcell" style="width: 5%;">№</th>
              <th class="table-3__cell  table-3__hcell" style="width: 80%;">{{ getTranslation('question') }}</th>
              <th class="table-3__cell  table-3__hcell" style="width: 15%;">{{ getTranslation('answer') }}</th>
            </tr>
            </thead>

            <tbody v-for="(type ,key) in results" v-bind:key="key" class="table-3__body">
            <tr class="table-3__row">
              <th colspan="3" class="table-3__cell">
                <h4 class="text-center">
                  {{ type.title }} - <span class="text--success">{{ type.totalTrue }}</span>/<span class="text--danger">{{ type.totalWrong }}</span>
                </h4>
              </th>
            </tr>
            <tr v-for="(item ,index) in type.questions" v-bind:key="index" class="table-3__row">
              <td class="table-3__cell">{{ item.priority }}</td>
              <td class="table-3__cell">
                <div :class="{'color-danger': !item.status}">
                  <MathJaxComponent v-if="item.type === 'fill_in'" :formula="item.question"/>
                  <span v-if="item.type !== 'fill_in'" v-html="item.question"></span>
                </div>
              </td>
              <td class="table-3__cell">
                <div v-if="item.status"> {{ getTranslation('correct') }}</div>
                <div v-else class="color-danger">{{ getTranslation('incorrect') }}</div>
              </td>
            </tr>
            </tbody>
          </table>

        </div>
        <!-- /.exam__content -->

      </div>
      <!-- /.row -->

    </main>
    <!--~~~~~     / PAGE CONTENT     ~~~~~-->


    <Footer/>

  </div>
  <!-- /wrapper -->
</template>

<script>
import Footer from "../layouts/Footer";
import LogoComponent from "../layouts/components/LogoComponent";
import testMixin from "../testing/mixins/test";
import MathJaxComponent from "../../../components/MathJaxComponent";

export default {
  name: "Index",
  mixins: [testMixin],
  components: {MathJaxComponent, LogoComponent, Footer},
  data() {
    return {
      results: [],
      tests: [],
      eventResults: {
        count_true: 0,
        count_total: 0
      },
      candidateEvent:{},
      eventInfo: {},
      wrongCount: 0,
      correctCount: 0,
      totalPoint: 0,
      showInfo: true,
    }
  },
  created() {
    this.fetchResults().then(async () => {
      for (let test of this.tests) {
        await this.fetchTestResults(test.id);
      }
    });

  },
  methods: {
    fetchResults() {
      return this.axios.get(this.$config.urls.candidateTesting.results.url, {params: {id: this.$route.params.id}})
          .then(response => {
            this.eventResults = response.data.data.results;
            this.tests = response.data.data.tests;
            this.eventInfo = response.data.data.eventInfo;
            this.candidateEvent = response.data.data.candidateEvent;
            this.totalPoint = response.data.data.totalPoint;
          }).catch(() => {
            this.$router.push({name: 'auth.success'}).catch(() => {
            });
          })
    },

    fetchTestResults(testId) {
      return this.axios.get(this.$config.urls.candidateTesting.testResults.url, {params: {id: testId}})
          .then(response => {

            let data = response.data.data;

            this.results.push(data);
          }).catch(() => {
            this.$router.push({name: 'auth.success'}).catch(() => {
            });
          })
    }
  }
}
</script>

<style scoped>
.exam__result-item--total {
  color: #2E71E5;
}

.exam__answers-num--total {
  background-color: #2E71E5;
}

.color-danger {
  color: #DA1A1A !important;
}

.exam__answers--point-total {
  float: left;
  display: -ms-flexbox;
  display: -webkit-box;
  display: flex;
  -ms-flex-align: center;
  -webkit-box-align: center;
  align-items: center;
  -ms-flex-pack: center;
  -webkit-box-pack: center;
  justify-content: center;
  margin-right: 8px;
  max-width: 100px;
  min-width: 60px;
  height: 32px;
  color: #fff;
  font-size: 16px;
  line-height: 1em;
  font-weight: bold;
  border-radius: 4px;
}
</style>
